'use client'
import React from 'react'

const VideoComponent = ({ videoUrl }) => {
    return (
        <div className='sm:hidden block mb-3 pb-3 border-b-[1px] border-b-forth'>
            <h2 id='video' className='text-maincolor font-semibold text-xl mb-1'>Intro Video</h2>
            <div className='w-full overflow-hidden'>
                <iframe className='w-full' height={'300'} src={videoUrl} title="Property Video" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
    )
}

export default VideoComponent